import { render, staticRenderFns } from "./ProgramMaterialsChange.vue?vue&type=template&id=60b163a6"
import script from "./ProgramMaterialsChange.vue?vue&type=script&lang=ts"
export * from "./ProgramMaterialsChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports